module.exports = __webpack_public_path__ + "img/icon-wallet-connect.fde9097f.svg";